<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="store"/>
          {{ $t('supplier') }}
        </h1>
      </div>
    </div>
    <invoice-gateway-list/>
  </main>
</template>

<script>
import InvoiceGatewayList from "@/views/vat-invoice/InvoiceGatewayList.vue";

export default {
  components: {InvoiceGatewayList},
  data() {
    return {}
  },
  i18n: {
    messages: {
      en: {
        supplier: 'Supplier'
      },
      vi: {
        supplier: 'Nhà cung cấp'
      }
    }
  },
}
</script>